import React, { useContext } from 'react';
import moment from 'moment';
import infoCircle from '../../assets/images/information-circle.svg';
import styles from './style.css';
import { FlowContext } from '../../core/flow-engine';

const NotificationBanner = () => {
  const { appState } = useContext(FlowContext);
  const {
    store: { loadedData }
  } = appState;

  const cutoffDate =
    loadedData?.contributionPeriod?.iraContributionPeriodCutoffDate;
  const priorYear = loadedData?.contributionPeriod?.priorYear;

  const date = moment(cutoffDate, 'MM-Do-YYYY');
  const cutoffDay = date.format('Do');
  const cutoffMonth = date.format('MMMM');
  const cutoffYear = date.format('YYYY');

  return (
    <div className="banner">
      <img
        src={infoCircle}
        className="info-circle"
        alt="tax year notification"
      />
      You can make {priorYear} tax-year contributions until {cutoffMonth}{' '}
      {cutoffDay}, {cutoffYear}.<style jsx>{styles}</style>
    </div>
  );
};

export default NotificationBanner;
